/* tslint:disable */

/**
 */
export class GenMeshParams {
    mesh_type?: number;
    size1?: number;
    size2?: number;
    size3?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/gen-mesh-params.ts